import React, { useState } from "react";
import clsx from "clsx";
import styles from './style.module.css';
import { SwitchProps } from "./Switch.types";
 


const Toggle: React.FC<SwitchProps> = ({ setIsHover, isActive}: SwitchProps) => {
     
    return (
        <div onClick={()=>{setIsHover( )}} className={clsx(styles.container ,  isActive && styles.Activecontainer )}>
            <div className={styles.circle} />
        </div>
    );
};

export default Toggle;

